/**
 * Cartão branco padrão para seções de filtro/conteúdo dos relatórios.
 */
const Cartao = ({ titulo, icone: Icone, className = "", children }) => (
  <div className={`bg-white rounded-2xl shadow-sm border border-gray-200 p-6 ${className}`}>
    {titulo && (
      <div className="flex items-center gap-2 mb-4">
        {Icone && <Icone size={18} className="text-brand-green" />}
        <h2 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
          {titulo}
        </h2>
      </div>
    )}
    {children}
  </div>
);

export default Cartao;
